import { t } from "ttag";

import { BiometricSwitch } from "@/shared/components";
import { ShieldCheckIcon } from "@/shared/ui";
import { ProfileCard } from "../components";

export const Biometric = () => {
  return (
    <ProfileCard.Root className="bg-neutral-400">
      <ProfileCard.Header>
        <ProfileCard.Title>{t`Security`}</ProfileCard.Title>
      </ProfileCard.Header>

      <ProfileCard.Content>
        <ProfileCard.Item className="bg-neutral-300">
          <ProfileCard.ItemLabel className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <ShieldCheckIcon className="size-4" />
              {t`Biometric Login`}
            </div>
            <BiometricSwitch />
          </ProfileCard.ItemLabel>
          <ProfileCard.ItemValue className="text-wrap">
            {t`Enable Face ID or Fingerprint to log in faster`}
          </ProfileCard.ItemValue>
        </ProfileCard.Item>
      </ProfileCard.Content>
    </ProfileCard.Root>
  );
};
